import { render } from "./MeetingManagerPage.vue?vue&type=template&id=b0ac64e4&scoped=true&ts=true"
import script from "./MeetingManagerPage.vue?vue&type=script&lang=ts"
export * from "./MeetingManagerPage.vue?vue&type=script&lang=ts"

import "./MeetingManagerPage.vue?vue&type=style&index=0&id=b0ac64e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0ac64e4"]])

export default __exports__